import React from 'react';
import gql from 'graphql-tag';
import { ListingFinancingCalloutFields } from '../schemas/rql';
import Item2AffirmCallout, { Item2AffirmCalloutFragment } from './item2_affirm_callout';
import { ListingKlarnaCallout, ListingKlarnaCalloutFragment } from './ListingKlarnaCallout';
import { hasPaymentMethodViaKlarna } from '../lib/klarnaExperiments';

type Listing = ListingFinancingCalloutFields.Fragment;

interface Props {
  listing: Listing;
  showKlarnaCallout?: boolean;
}

export function ListingFinancingCallout({
  listing,
  showKlarnaCallout = false,
}: Props) {
  if (hasPaymentMethodViaKlarna(listing.acceptedPaymentMethods) && showKlarnaCallout) {
    return (
      <ListingKlarnaCallout
        listing={listing}
      />
    );
  }

  return (
    <Item2AffirmCallout
      data={listing}
      simpleZeroPercentNudge
    />
  );
}

export const ListingFinancingCalloutFragment = gql`
  fragment ListingFinancingCalloutFields on Listing {
    _id
    acceptedPaymentMethods
    ...Item2AffirmCalloutData
    ...ListingKlarnaCalloutFields
  }
  ${Item2AffirmCalloutFragment}
  ${ListingKlarnaCalloutFragment}
`;
